package com.sweetlime.bingeamigo.util

import kotlin.random.Random

object UsernameGenerator {

    private val adjectives = listOf(
        "Cosmic", "Rogue", "Iconic", "Silent", "Mystic", "Stellar", "Epic", "Noir",
        "Brave", "Cryptic", "Legendary", "Cinematic", "Dramatic", "Cult", "Classic",
        "Phantom", "Reel", "Golden", "Silver", "Velvet", "Midnight", "Neon", "Retro",
        "Surreal", "Twisted", "Haunted", "Wicked", "Daring", "Fearless", "Savage"
    )

    private val nouns = listOf(
        "Binger", "Cinephile", "Watcher", "Critic", "Pilot", "Detective", "Ranger",
        "Agent", "Hero", "Villain", "Director", "Auteur", "Cameo", "Extra", "Sidekick",
        "Rebel", "Maverick", "Renegade", "Outlaw", "Nomad", "Voyager", "Sleuth",
        "Phantom", "Specter", "Oracle", "Scribe", "Curator", "Archivist", "Projector"
    )

    fun generate(): String {
        val adj = adjectives[Random.nextInt(adjectives.size)]
        val noun = nouns[Random.nextInt(nouns.size)]
        val number = Random.nextInt(10, 9999)
        return "$adj$noun$number"
    }
}